export default "__VITE_ASSET__99a47333__"